import { Component, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { TaskHistory } from '@/types';
import { DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AgpmService } from '../agpm.service';
import { getAgpmTaskHistoryDataTableStructure } from './utils/agpm-task-history-data-table-object';

@Component({
  selector: 'sm-task-history',
  imports: [PageHeaderComponent, DataTableBuilderComponent],
  templateUrl: './task-history.component.html',
  styleUrl: './task-history.component.scss',
})
export class AgpmTaskHistoryComponent implements OnInit {
  agpmService = inject(AgpmService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);

  breadcrumb = [
    {
      label: 'agpm.breadcrumb.agpm',
      routerLink: ['/agpm-current-notice'],
    },
    {
      label: 'agpm.breadcrumb.agpmTaskHistory',
      routerLink: ['/agpm-task-history'],
    },
  ];

  processInstanceId = this.activatedRoute.snapshot.params['processInstanceId'];

  loading = true;
  data: TaskHistory[] = [];
  datatableObject: DynamicDataTable = getAgpmTaskHistoryDataTableStructure({
    translate: (key: string) => this.translate.instant(key),
  });

  ngOnInit(): void {
    if (!this.processInstanceId) return;
    this.agpmService.getAgpmTaskHistory(this.processInstanceId).subscribe(history => {
      this.data = history;
      this.loading = false;
    });
  }
}
